import React, { Component } from 'react';
import
{
  DtpHeader,
  DtpMenu,
  DtpMenuItem,
  DtpMenuDropdown,
} from 'dtp-react-components';
import PropType from 'prop-types';
import { connect } from 'react-redux';
import ProtectedItem from '../ComponentesAutenticacao/ProtectedItem';
import * as auth from '../ComponentesAutenticacao/utils';
import User from '../../domain/User';

const appInfo = {
  firstName: 'Comprev',
  lastName: null,
  owner: 'Compensação Previdenciária',
};

const naoPossuiLotacao = 'Lotação não informada';
class Header extends Component {
  getPapel = (role) => {
    let array = '';
    if (role.indexOf('|PA|') !== -1) {
      array = role.split('|');
    }
    let papel = '';
    for (let i = 0, tam = array.length; i < tam; i += 1) {
      if (array[i] === 'PA') {
        papel = array[i + 1];
        break;
      }
    }
    return papel;
  }

  getLotacao = (roles) => {
    let array = '';
    const lotacao = [];
    roles.forEach((role) => {
      const eNovo = role.match(/TD/g);
      const temPA = role.indexOf('|PA|') !== -1;
      if (temPA && eNovo) {
        array = role.split('|');
        for (let i = 0, tam = array.length; i < tam; i += 1) {
          if (array[i] === 'TD') {
            lotacao.push(array[i + 3]);
            break;
          }
        }
      }
    });
    return lotacao;
  }

  getPapeis = (roles) => {
    let array = '';
    const papeis = [];
    roles.forEach((role) => {
      const temPA = role.indexOf('|PA|') !== -1;
      if (temPA) {
        array = role.split('|');
        for (let i = 0, tam = array.length; i < tam; i += 1) {
          if (array[i] === 'PA') {
            papeis.push(array[i + 1]);
            break;
          }
        }
      }
    });
    return papeis;
  }

  getUserDataForHeader = () => {
    if (this.props.userData) {
      let papelUsuario = '';
      let lotacaoUsuario = '';
      let papeisUsuarios = '';
      let infoUsuario = '';

      if (this.props.userData.roles) {
        papeisUsuarios = this.getPapeis(this.props.userData.roles);
        lotacaoUsuario = this.getLotacao(this.props.userData.roles);

        if (papeisUsuarios.length > 0) {
          for (let i = 0, tam = papeisUsuarios.length; i < tam; i += 1) {
            papelUsuario = `${papelUsuario}\n${papeisUsuarios[i]}`;
          }
        }
        const primParte = [];
        const segParte = [];
        if (lotacaoUsuario.length > 0) {
          if (lotacaoUsuario[0].indexOf('#') !== -1) {
            const arrayLotacao = lotacaoUsuario[0].split('#');
            primParte.push(arrayLotacao[0]);
            segParte.push(arrayLotacao[1]);
            lotacaoUsuario = `${primParte[0]}\n${segParte[0]}`;
          }
        } else {
          lotacaoUsuario = naoPossuiLotacao;
        }

        infoUsuario = (`${papelUsuario}\n${lotacaoUsuario}`).trim();

        if (infoUsuario.length > 36) {
          let primParteInfo = [];
          const segParteInfo = [];
          if (infoUsuario.indexOf('@') !== -1) {
            const array = infoUsuario.split('@');
            primParteInfo.push(array[0]);
            primParteInfo = `${primParteInfo}@`;
            segParteInfo.push(array[1]);
          }
          const texto = `${primParteInfo}\n${segParteInfo}`;
          infoUsuario = texto.trim();
        }
      }

      if (this.props.userData.lotacoes.length === 0) {
        this.props.userData.lotacoes.push('naoUsada');
      }

      return {
        firstName: this.props.userData.givenName,
        document: {
          label: 'CPF',
          number: this.props.userData.prevCpf,
        },
        information: infoUsuario,
      };
    }
    return null;
  }

  isMenuItemActive(key, isMenuConsulta) {
    if (isMenuConsulta) {
      return this.props.location.pathname === key;
    }
    return this.props.location.pathname.search(key) !== -1;
  }

  doLogout = () => {
    auth.logout();
    const { comprevCasUrl, comprevBaseUrl } = window.comprevConfig;
    window.open(`${comprevCasUrl}/logout?url=${comprevBaseUrl}`, '_self');
  }

  doLogin = () => {
    const { comprevCasUrl, comprevBaseUrl } = window.comprevConfig;
    const { casClientId } = window.comprevConfig;
    if (sessionStorage.getItem('comprevConfigLogotipo')) {
      const logotipoJson = { exibirLogo: 0 };
      window.comprevConfigLogotipo = logotipoJson;
      sessionStorage.setItem('comprevConfigLogotipo', JSON.stringify(logotipoJson));
    }
    window.open(`${comprevCasUrl}/oauth2.0/authorize?client_id=${casClientId}&response_type=token&redirect_uri=${comprevBaseUrl}`, '_self');
  }

  isFirstPage() {
    const cleanPath = this.props.location.pathname.replace('/', '');
    return cleanPath.length === 0;
  }

  estaComBloqueioAtivoContratoDtp() {
    return this.props.configuracoesFrontend &&
    !this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp;
  }

  handleMenu = () => (
    <DtpMenu>
      <DtpMenuItem
        label="Início"
        key={1}
        active={this.isFirstPage()}
        path="/"
      />
      { User.logged() &&
        <React.Fragment>
          { this.estaComBloqueioAtivoContratoDtp() &&
            <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp']}>
              <DtpMenuDropdown
                label="Requerimento"
                key={2}
                active={this.isMenuItemActive('requerimento')}
              >
                <DtpMenuItem
                  label="Aposentadoria"
                  key={2.1}
                  active={this.isMenuItemActive('requerimento/aposentadoria/novo')}
                  path="/requerimento/aposentadoria/novo"
                />
                <DtpMenuItem
                  label="Pensão"
                  key={2.2}
                  active={this.isMenuItemActive('requerimento/pensao/novo')}
                  path="/requerimento/pensao/novo"
                />
                <ProtectedItem allowedPermissions={['requerer-compensacao-rpps', 'analisar-compensacao-rpps']}>
                  <DtpMenuItem
                    label="Complementação"
                    key={2.3}
                    active={this.isMenuItemActive('/consulta/complementar-aposentadoria/rpps', true)}
                    path="/consulta/complementar-aposentadoria/rpps"
                  />
                </ProtectedItem>
              </DtpMenuDropdown>
            </ProtectedItem>
          }
          {/* <ProtectedItem allowedPermissions={['requerer-compensacao-rpps']}>
            <DtpMenuDropdown
              label="CTC"
              key={12}
              active={this.isMenuItemActive('ctc')}
            >
              <DtpMenuItem
                label="Cadastrar CTC"
                key={12.1}
                active={this.isMenuItemActive('/repositorioctc/consulta/ctc/rpps', true)}
                path="/repositorioctc/consulta/ctc/rpps"
              />
            </DtpMenuDropdown>
          </ProtectedItem> */}
          <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp']}>
            <DtpMenuDropdown
              label="Exigência"
              key={3}
              active={this.isMenuItemActive('exigencia')}
            >
              <DtpMenuItem
                label="Prazo"
                key={3.1}
                active={this.isMenuItemActive('/consulta/exigencia/rgps', true)}
                path="/consulta/exigencia/rgps"
              />
              <DtpMenuItem
                label="Prescrição"
                key={3.2}
                active={this.isMenuItemActive('/consulta/prescricao-exigencia/rgps', true)}
                path="/consulta/prescricao-exigencia/rgps"
              />
              <DtpMenuItem
                label="Indeferido"
                key={3.3}
                active={this.isMenuItemActive('exigencia', true)}
                path="/exigencia/indeferidos/rgps"
              />
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['requerer-compensacao-rpps']}>
            <DtpMenuDropdown
              label="Exigência"
              key={3}
              active={this.isMenuItemActive('exigencia')}
            >
              <DtpMenuItem
                label="Prazo"
                key={3.1}
                active={this.isMenuItemActive('/consulta/exigencia/rpps', true)}
                path="/consulta/exigencia/rpps"
              />
              <DtpMenuItem
                label="Prescrição"
                key={3.2}
                active={this.isMenuItemActive('/consulta/prescricao-exigencia/rpps', true)}
                path="/consulta/prescricao-exigencia/rpps"
              />
              <DtpMenuItem
                label="Indeferido"
                key={3.3}
                active={this.isMenuItemActive('exigencia', true)}
                path="/exigencia/indeferidos/rpps"
              />
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['analisar-compensacao-rgps']}>
            <DtpMenuItem
              label="Análise"
              key={4}
              active={this.isMenuItemActive('/consulta/analise', true)}
              path="/consulta/analise/rgps"
            />
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['requerer-compensacao-rpps', 'gerenciar-negocio-dcomp']}>
            <DtpMenuDropdown
              label="Análise"
              key={4}
              active={this.isMenuItemActive('/consulta/analise', true)}
            >
              <DtpMenuItem
                label="RGPS"
                key={4.1}
                active={this.isMenuItemActive('/consulta/analise/rgps', true)}
                path="/consulta/analise/rgps"
              />
              <DtpMenuItem
                label="RPPS"
                key={4.2}
                active={this.isMenuItemActive('/consulta/analise/rpps', true)}
                path="/consulta/analise/rpps"
              />
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['fornecer-parecer-medico-rpps']}>
            <DtpMenuItem
              label="Parecer Médico"
              key={5}
              active={this.isMenuItemActive('/consulta/parecer-medico', true)}
              path="/consulta/parecer-medico/rpps"
            />
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
            'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps',
            'auditar-comprev', 'analisar-negocio-dtpv']}
          >
            <DtpMenuItem
              label="Consulta"
              key={6}
              active={this.isMenuItemActive('/consulta/rgps', true)}
              path="/consulta/rgps"
            />
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['analisar-compensacao-rpps', 'consultar-compensacao-rpps']}>
            <DtpMenuItem
              label="Consulta"
              key={6}
              active={this.isMenuItemActive('/consulta/rpps', true)}
              path="/consulta/rpps"
            />
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-negocio-sprev',
            'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp',
            'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
            'analisar-negocio-dtpv']}
          >
            <DtpMenuDropdown
              label="Cadastro"
              key={7}
              active={this.isMenuItemActive('cadastros')}
            >
              <DtpMenuItem
                label="Média RGPS"
                key={7.1}
                active={this.isMenuItemActive('/cadastros/valoresMediosBeneficios/novo')}
                path="/cadastros/valoresMediosBeneficios/novo"
              />
              <DtpMenuItem
                label="Regime Próprio de Previdência (RPPS)"
                key={7.2}
                active={this.isMenuItemActive('/consultaEnteFederativo/consulta-rpps')}
                path="/consultaEnteFederativo/consulta-rpps"
              />
              <ProtectedItem allowedPermissions={['analisar-negocio-sprev', 'analisar-negocio-dtpv']}>
                <DtpMenuItem
                  label="Orgãos Vinculados da União"
                  key={7.3}
                  active={this.isMenuItemActive('/cadastros/OrgaosVinculadosUniao')}
                  path="/cadastros/OrgaosVinculadosUniao"
                />
                <DtpMenuItem
                  label="Períodos RPPS da União"
                  key={7.4}
                  active={this.isMenuItemActive('/cadastros/PeriodosRppsUniao')}
                  path="/cadastros/PeriodosRppsUniao"
                />
              </ProtectedItem>
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps',
            'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'analisar-contrato-dtpv', 'analisar-negocio-dtpv']}
          >
            <DtpMenuDropdown label="Pagamento" key={8} active={this.isMenuItemActive('pagamento')}>
              <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps',
                'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp']}
              >
                <DtpMenuItem
                  label="Cessação Manual"
                  key={8.1}
                  active={this.isMenuItemActive('/consultaCessacaoRequerimento/cessacao-requerimento')}
                  path="/consultaCessacaoRequerimento/cessacao-requerimento"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}>
                <DtpMenuItem
                  label="Bloqueio e Desbloqueio de Entes Federativos"
                  key={8.2}
                  active={this.isMenuItemActive('/consultaBloqueio/bloqueio')}
                  path="/consultaBloqueio/bloqueio"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['gerenciar-negocio-dcomp']}>
                <DtpMenuItem
                  label="Glosa de Dação"
                  key={8.3}
                  active={this.isMenuItemActive('/consultaGlosaDeDacao/consulta-glosa')}
                  path="/consultaGlosaDeDacao/consulta-glosa"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['gerenciar-negocio-dcomp']}>
                <DtpMenuItem
                  label="Fechamento de Pagamentos"
                  key={8.4}
                  active={this.isMenuItemActive('/consulta/consultaPagamentos', true)}
                  path="/consulta/consultaPagamentos"
                />
              </ProtectedItem>
              <ProtectedItem
                allowedPermissions={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps',
                  'auditar-comprev', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
              >
                <DtpMenuItem
                  label="Controle de Pagamentos"
                  key={8.5}
                  active={this.isMenuItemActive('/controledepagamentos/home/controle-pagamentos', true)}
                  path="/controledepagamentos/home/controle-pagamentos"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['analisar-negocio-sprev']}>
                <DtpMenuItem
                  label="Cronograma de Pagamento"
                  key={8.6}
                  active={this.isMenuItemActive('/cadastros/cronogramaPagamento', true)}
                  path="/cadastros/cronogramaPagamento"
                />
              </ProtectedItem>
              <ProtectedItem
                allowedPermissions={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps',
                  'analisar-compensacao-rpps', 'auditar-comprev', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
              >
                <DtpMenuItem
                  label="Controle de Débitos Carregados RGPS"
                  key={8.7}
                  active={this.isMenuItemActive('/controledepagamentos/home/controle-debitos-pendentes', true)}
                  path="/controledepagamentos/home/controle-debitos-pendentes"
                />
              </ProtectedItem>
              <ProtectedItem
                allowedPermissions={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps',
                  'auditar-comprev', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
              >
                <DtpMenuItem
                  label="Pendências"
                  key={8.8}
                  active={this.isMenuItemActive('/controledepagamentos/home/pendencias', true)}
                  path="/controledepagamentos/home/pendencias"
                />
              </ProtectedItem>
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp',
            'auditar-comprev', 'analisar-negocio-dtpv']}
          >
            <DtpMenuDropdown
              label="Gerencial"
              key={9}
              active={this.isMenuItemActive('gerencial')}
            >
              <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv']}>
                <DtpMenuItem
                  label="Consulta Fila Migração do PRISMA"
                  key={9.1}
                  active={this.isMenuItemActive('/consultaPrisma/consulta-prisma')}
                  path="/consultaPrisma/consulta-prisma"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'auditar-comprev',
                'analisar-negocio-dtpv']}
              >
                <DtpMenuItem
                  label="Consulta por Tipo de Auditoria"
                  key={9.2}
                  active={this.isMenuItemActive('/consultaAuditoria/auditoria', true)}
                  path="/consultaAuditoria/auditoria"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['analisar-negocio-dtpv', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp', 'analisar-negocio-sprev']}>
                <DtpMenuItem
                  label="Consulta Fila do GET"
                  key={9.3}
                  active={this.isMenuItemActive('/consultaPrisma/consulta-prisma')}
                  path="/consultaFilaGet/consulta-filaget"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['analisar-negocio-dtpv', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']}>
                <DtpMenuItem
                  label="Consulta Operações com o GET"
                  key={9.4}
                  active={this.isMenuItemActive('/consultaOperacoesGet/consulta-operacoes-get')}
                  path="/consultaOperacoesGet/consulta-operacoes-get"
                />
              </ProtectedItem>
              <ProtectedItem allowedPermissions={['analisar-negocio-dtpv', 'analisar-negocio-sprev']}>
                <DtpMenuItem
                  label="Mensagens"
                  key={9.4}
                  active={this.isMenuItemActive('/mensagens/novo')}
                  path="/mensagens/novo"
                />
              </ProtectedItem>
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
            'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps',
            'auditar-comprev', 'analisar-negocio-dtpv']}
          >
            <DtpMenuDropdown
              label="Relatórios"
              key={10}
              id="Relatorios"
            >
              <DtpMenuItem
                label="Pagamentos"
                key={10.1}
                active={this.isMenuItemActive('/relatorios/pagamentos', true)}
                path="/relatorios/pagamentos"
              />
              <DtpMenuItem
                label="Requerimentos (Totalizadores por Estados)"
                key={10.2}
                active={this.isMenuItemActive('/relatorios/totalizador/estados', true)}
                path="/relatorios/totalizador/estados"
              />
              <DtpMenuItem
                label="Requerimentos (Analítico)"
                key={10.3}
                active={this.isMenuItemActive('/relatorios/estado/tipo', true)}
                path="/relatorios/estado/tipo"
              />
              <DtpMenuItem
                label="Exigências"
                key={10.4}
                active={this.isMenuItemActive('/relatorios/estado/exigencias', true)}
                path="/relatorios/estado/exigencias"
              />
              <DtpMenuItem
                label="Exigências (Analítico)"
                key={10.5}
                active={this.isMenuItemActive('/relatorios/estado/exigencias', true)}
                path="/relatorios/estado/exigencias/analitico"
              />
              <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-negocio-sprev',
                'analisar-negocio-dtpv', 'gerenciar-negocio-dcomp', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']}
              >
                <DtpMenuItem
                  label="Simulação de Compensação"
                  key={10.6}
                  active={this.isMenuItemActive('/relatorios/simulacaocompensacao', true)}
                  path="/relatorios/simulacaocompensacao"
                />
              </ProtectedItem>
              <DtpMenuItem
                label="Conflitos de Períodos"
                key={10.7}
                active={this.isMenuItemActive('/relatorios/conflito-periodos', true)}
                path="/relatorios/conflito-periodos"
              />
            </DtpMenuDropdown>
          </ProtectedItem>
          <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
            'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps',
            'auditar-comprev', 'analisar-negocio-dtpv', 'analisar-contrato-dtpv', 'fornecer-parecer-medico-rpps']}
          >
            <DtpMenuDropdown
              label="Ferramentas"
              key={11}
              id="Ferramentas"
            >
              <DtpMenuItem
                label="Acréscimos Legais"
                key={11.1}
                active={this.isMenuItemActive('/calculadora/acrescimos-legais', true)}
                path="/calculadora/acrescimos-legais"
              />
              <DtpMenuItem
                label="Requerimentos por CPF"
                key={11.2}
                active={this.isMenuItemActive('/consulta-cpf/consultacpf', true)}
                path="/consulta-cpf/consultacpf"
              />
              <DtpMenuItem
                label="Conversor ano mes dia para dia"
                key={11.3}
                active={this.isMenuItemActive('/conversor-amd/conversor', true)}
                path="/conversor-amd/conversor"
              />
              {/* <DtpMenuItem
                label="Soma/Subtração de datas"
                key={11.4}
                active={this.isMenuItemActive('/calculador-amd/calculador', true)}
                path="/calculador-amd/calculador"
              /> */}
              <DtpMenuItem
                label="Calculadora de Períodos"
                key={11.5}
                active={this.isMenuItemActive('/calculadora-periodos/calculadoraperiodos', true)}
                path="/calculadora-periodos/calculadoraperiodos"
              />
              {/*
                <ProtectedItem allowedPermissions={['analisar-negocio-dtpv']}>
                  <DtpMenuItem
                    label="Extrato Cnis"
                    key={11.6}
                    active={this.isMenuItemActive('/consultaExtratoCnis/consulta-extrato', true)}
                    path="/consultaExtratoCnis/consulta-extrato"
                  />
                </ProtectedItem>
              */}
            </DtpMenuDropdown>
          </ProtectedItem>
        </React.Fragment>
      }
    </DtpMenu>
  )

  render() {
    const menu = this.handleMenu();

    return (
      <DtpHeader
        appInfo={appInfo}
        showInfoBarBtn={false}
        userData={this.getUserDataForHeader()}
        doLogout={this.doLogout}
        doLogin={this.doLogin}
        showUserInfo
      >
        {menu}
      </DtpHeader>
    );
  }
}

Header.defaultProps = {
  userData: null,
  configuracoesFrontend: null,
};

Header.propTypes = {
  configuracoesFrontend: PropType.arrayOf(PropType.string),
  // logout: PropType.func.isRequired,
  location: PropType.shape({ pathname: PropType.string }).isRequired,
  userData: PropType.shape(),
};

const mapStateToProps = state => ({
  configuracoesFrontend: state.base.configuracoesFrontend,
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx